<script lang="ts">
  import { recommendation } from "../../stores/recommendation"

  import ExpertAvatar from "./ExpertAvatar.svelte"
  import Text from "../Common/Text.svelte"
  import Caption from "../Common/Caption.svelte"

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: expert = $recommendation.details?.expert
</script>

{#if expert}
  <div class="expert-heading">
    <ExpertAvatar />
    <div class="expert-name-title">
      <Text class="expert-name">
        {expert.name}
      </Text>
      <Caption class="expert-title">
        {expert.title}
      </Caption>
    </div>
  </div>
{/if}
